import React from "react";
import styles from "./IconAndLabel.module.css";

const IconAndLabel = ({ icon, label, onClick, bgColor }) => {
  return (
    <div
      className={styles.wrapper}
      style={{ backgroundColor: bgColor || "var(--Utility_Color1)" }}
      onClick={onClick}
    >
      <span className={styles.icon}>{icon}</span>
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default IconAndLabel;
